/*
 * @Author: edconstdchen
 * @Date:   2016-02-26 15:48:11
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-08-16 19:30:45
 */

const _ = require('lodash');

const utility = require('./helper');

const HTML = require('./video.ejs');

const template = _.template(HTML);

function video(data) {
  let ratio = data.width ? Number(data.height / data.width) : 0;
  ratio = utility.ratioToPercent(ratio);
  return template({
    title: '',
    tag: '延伸视频',
    height: ratio,
    vid: _.escape(data.sVid || data.vid),
    src: _.escape(data.sVal),
    poster: _.escape(data.sPoster)
  });
}

module.exports = video;



// WEBPACK FOOTER //
// ./src/HTMLTag/video.js